import { render, staticRenderFns } from "./indexNoMenu.vue?vue&type=template&id=22510486&scoped=true"
import script from "./indexNoMenu.vue?vue&type=script&lang=js"
export * from "./indexNoMenu.vue?vue&type=script&lang=js"
import style0 from "./indexNoMenu.vue?vue&type=style&index=0&id=22510486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22510486",
  null
  
)

export default component.exports